import { FeatureFlagOptions } from './types'

export const JUS_IA_RELATED_QUESTIONS_VARIANTS = {
  SPARKLY_INPUT_BOTTOM: 'sparkly-input-bottom',
  DULL_INPUT_TOP: 'dull-input-top',
} as const

export const STREAMLINE_JURIS_DOCVIEW_INSIGHTS_VARIANTS = {
  LEFT_ASIDE: 'left_aside',
  PROCEDURAL_ACTS_TAB: 'procedural_acts_tab',
  LAWSUIT_DETAILS_BELOW_TITLE: 'lawsuit_details_below_title',
} as const

export const JUSIA_SELECTION_SHORTCUT_VARIANTS = {
  CONTROL: 'control',
  ENABLED: 'enabled',
} as const

export const LAWSUIT_ANALYSIS_V2_VARIANTS = {
  ENABLED: 'enabled',
} as const

export const LAWSUIT_MOTIONS_VARIANTS = {
  INLINE_SECTION: 'inline_section',
} as const

export const MAIN_CLAIM_VARIANTS = {
  ENABLED: 'enabled',
} as const

export const GROWTH_BOOK_FEATURE_FLAGS: Record<string, FeatureFlagOptions> = {
  JUS_IA_RELATED_QUESTIONS: {
    name: 'jus_ia_related_questions_in_juris_docview_v2',
    values: Object.values(JUS_IA_RELATED_QUESTIONS_VARIANTS),
  },
  STREAMLINE_JURIS_DOCVIEW_INSIGHTS: {
    name: 'streamline_juris_docview_insights',
    values: Object.values(STREAMLINE_JURIS_DOCVIEW_INSIGHTS_VARIANTS),
  },
  JUS_IA_SELECTION_SHORTCUT: {
    name: 'jus_ia_selection_shortcut',
    values: Object.values(JUSIA_SELECTION_SHORTCUT_VARIANTS),
  },
  LAWSUIT_ANALYSIS_V2: {
    name: 'lawsuit_analysis_v2',
    values: Object.values(LAWSUIT_ANALYSIS_V2_VARIANTS),
  },
  LAWSUIT_MOTIONS: {
    name: 'pecas_processo_inline_section',
    values: Object.values(LAWSUIT_MOTIONS_VARIANTS),
  },
  THESIS_SECURITY: {
    name: 'thesis_security_in_juris_docview',
    values: ['accordion', 'card'],
  },
  MAIN_CLAIM: {
    name: 'juris_main_claim',
    values: Object.values(MAIN_CLAIM_VARIANTS),
  },
} as const
